import React, { useContext, useEffect } from 'react';
import { CHATWOOT_BASE_URl, CHATWOOT_TOKEN } from '../../../constants';
import { setChatwootUser } from '../../../hooks/useChatwootUser';

const ChatwootWidget = ({ user }) => {

    useEffect(() => {
        handleChatwoot();
        window.addEventListener("chatwoot:ready", () => setChatwootUser(user));
        return () => window.removeEventListener("chatwoot:ready", () => setChatwootUser(user));
      }, [])

      const handleChatwoot = () => {

        window.chatwootSettings = {
          hideMessageBubble: false,
          position: 'right',
          locale: 'en',
          type: 'standard',
        };
    
        var g = document.createElement("script"), s = document.getElementsByTagName("script")[0];
        g.src = CHATWOOT_BASE_URl + "/packs/js/sdk.js";
        s.parentNode.insertBefore(g, s);
        g.async = !0;
        g.onload = function () {
          window.chatwootSDK.run({
            websiteToken: CHATWOOT_TOKEN,
            baseUrl: CHATWOOT_BASE_URl
          });
          window.$chatwoot.setCustomAttributes({
            accountId: 1,
            pricingPlan: "paid",
            status: "active",
          });
        }
      }
    
    
    return null
}

export default ChatwootWidget